
















































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import httpApi from "@/API/Tenant/Weixin";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
@Component({
  components: {}
})
export default class extends Vue {
  @Prop() PosterId!: any;
  private groupList: any = []; //分组数据列表
  private TagidData: any = []; //微信粉丝标签列表
  private GetAppData: any = {}; //当前应用号信息
  private loading: boolean = false;
  private BasicInformationData: any = {
    eventName: "",
    group: "",
    keyWords: "",
    reward: true,
    labelDisplay: true,
    label: "",
    activityTime: "",
    //海报有效期
    expirationDate: { day: 10, hour: 0, minute: 0 },
    Status: 1
  };
  data() {
    //验证必填字段
    return {
      rules: {
        eventName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        group: [
          { required: true, message: "请选择活动分组", trigger: "change" }
        ],
        keyWords: [
          {
            required: true,
            message: "请输入在公众号触发的关键词",
            trigger: "blur"
          }
        ],
        activityTime: [
          {
            required: true,
            message: "请选择活动开始结束时间",
            trigger: "change"
          }
        ],
        expirationDate: [
          { required: true, message: "请选择海报有效时间", trigger: "change" }
        ]
      }
    };
  }
  //初始化页面
  created() {
    // console.log(this.PosterId);
    Bus.$on("posterInfo", (Item: any) => {
      //this.BasicInformationData = Item;
      if (Item) {
      }
    });

    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    this.GetSarchTagsAsync();
    this.loadGroupsList();
    this.editData();
  }
  //加载分组数据
  async loadGroupsList() {
    let params: any = {
      Input: [
        {
          Name: "PromotePosterListDTO",
          Value: {
            TenantId: this.GetAppData.TenantID,
            Aid: this.GetAppData.Aid
          }
        }
      ]
    };
    this.loading = true;
    var res: any = await httpApi.GetPosterGroupsListAsync(params);
    this.loading = false;
    if (res.ErrorCode == 0) {
      res.output[0].value.forEach((e: any) => {
        this.groupList.push(e.Groups);
      });
      //
    } else {
      this.$message.error("加载分组数据失败：" + res.ErrorMessage);
    }
    //console.log(res);
    //GetPosterGroupsListAsync
  }

  //修改数据加载
  async editData() {    
     let id = localStorage.getItem("PosterDataId");
    //let id = getCookie("PosterId");
    if (id) {
      if (parseInt(id) > 0) {
        let params: any = {
          Input: [
            {
              Name: "PromotePosterListDTO",
              Value: {
                TenantId: this.GetAppData.TenantID,
                Aid: this.GetAppData.Aid,
                PosterId: id,
                WxQrCode: getCookie("WxQrCode")
              }
            }
          ]
        };
        var res: any = await httpApi.GetPosterModel(params);
        if (res.ErrorCode == 0) {
          console.log(res);
          let activityTime: any = [];
          let data = res.output[0].value;
          console.log(data);
          if (data) {
            activityTime.push(data.EventStartTime.replace("T", " "));
            activityTime.push(data.EventEndTime.replace("T", " "));
            /* this.BasicInformationData = {
            eventName: data.EventName,
            group: data.Groups,
            keyWords: data.KeyWords,
            reward: data.Reward,
            labelDisplay: !data.Label,
            label: data.Label,
            activityTime: activityTime,
            //海报有效期
            expirationDate: JSON.parse(data.PosterValidity),
            Status: parseInt(data.Status)
          };*/
            this.BasicInformationData.activityTime = activityTime;
            if (data.EventName)
              this.BasicInformationData.eventName = data.EventName;
            if (data.Groups) this.BasicInformationData.group = data.Groups;
            if (data.KeyWords)
              this.BasicInformationData.keyWords = data.KeyWords;
            this.BasicInformationData.reward = data.Reward;
            this.BasicInformationData.labelDisplay = false;
         
            if (data.Label) {
              this.BasicInformationData.labelDisplay = true;
              this.BasicInformationData.label = parseInt(data.Label);
            }            

            if (data.PosterValidity)
              this.BasicInformationData.expirationDate = JSON.parse(
                data.PosterValidity
              );
            if (data.Status)
              this.BasicInformationData.Status = parseInt(data.Status);
            this.refresh();
          }
        } else {
          this.$message.error("加载修改数据失败：" + res.ErrorMessage);
        }
      }
    }
  }
  //传值给父级页面
  refresh() {
    Bus.$emit("BasicInformationData", this.BasicInformationData);
  }
  //增加分组
  addgroup() {
    this.$prompt("请输入分组名称", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消"
    })
      .then((data: any) => {
        // console.log(data.value);
        this.groupList.push(data.value);
        this.BasicInformationData.group = data.value;
        this.refresh();
        // this.$message({
        //   type: "success",
        //   message: "你的分组名称是: " + value
        // });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      });
  }
  //增加标签
  addLabel() {
    this.$prompt("请输入标签名称", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消"
    })
      .then((data: any) => {
        console.log(data.value);
        //创建粉丝标签
        this.saveTag(data.value);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      });
  }
  //保存标签
  async saveTag(vaule: string) {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      //console.log(this.AddAccountForm);
      let saveData: any = {
        ActionName: "CREATE",
        ApplicationId: AppAccount.Aid,
        WxName: vaule
      };
      let params: any = {
        Input: [
          {
            Name: "model",
            Value: saveData
          }
        ]
      };
      console.log(params);
      var res: any = await httpApi.SaveSynchronousTagsAsync(params);
      console.log(res);
      if (res.ErrorCode == 0) {
        this.$message.success("新增标签成功！");
        this.GetSarchTagsAsync();
      } else {
        this.$message.error(res.ErrorMessage);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
  //加载标签分组
  async GetSarchTagsAsync() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          {
            Name: "Aid",
            Value: AppAccount.Aid
          },
          {
            Name: "act",
            Value: "userList"
          }
        ]
      };
      var res: any = await httpApi.SarchTags(params);
      if (res.ErrorCode == 0) {
        //console.log(res);

        this.TagidData = res.output[0].value;
        console.log(this.TagidData);
      }
    } else {
      this.$router.push("/home"); //缓存失效回返
    }
  }
}
